import axios from 'axios'
import HTTP from './http'

export default {
    createReplacedRows: payload => axios.post(HTTP.CREATE_REPLACE_ROWS, payload),
    applyActions: payload => axios.post(HTTP.REPLACED_APPLY_ACTIONS, payload),
    getReplacedCards: payload => axios.post(HTTP.REPLACED_LIST, payload),
    handleReplacedCard: (payload: {
        id: number
        archive: 'error' | 'process'
        index: number
        action?: 'sto' | 'block' | 'cancellation'
        resolve_status?: 'error' | 'done' | 'handled' | 'no_handle_need'
        resolved?: boolean
    }) =>
        axios.post(HTTP.REPLACED_HANDLE, payload),
    getBatchStatus: (date: string) => axios.get(HTTP.REPLACED_BATCH_STATUS, { params: { date } }),
    getApplyRequireDates: () => axios.get(HTTP.REPLACED_APPLY_REQUIRE_DATES),
    getApplyRequireRows: (date: string, socketId?: string, requestId?: number) =>
        axios.get(HTTP.REPLACED_APPLY_REQUIRE_ROWS, { params: { date, socket_id: socketId, request_id: requestId } })
}
